import React from 'react';

/**
 * WeTV 图标组件集合
 * 按需引入，支持自定义尺寸和样式
 */

export interface IconProps {
  className?: string;
  size?: number;
  width?: number;
  height?: number;
}

export interface VipBadgeIconProps extends IconProps {
  expired?: boolean;
}
// 手机图标
export const PhoneIcon: React.FC<IconProps> = ({ className, size, width = 40, height = 40 }) => {
  const resolvedWidth = size ?? width;
  const resolvedHeight = size ?? height;
  return (
    <svg
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="9" y="5" width="22" height="30" stroke="currentColor" strokeWidth="2.5" />
      <rect x="16" y="27" width="8" height="2.5" fill="currentColor" />
    </svg>
  );
};

// 邮箱图标
export const EmailIcon: React.FC<IconProps> = ({ className, size, width = 40, height = 40 }) => {
  const resolvedWidth = size ?? width;
  const resolvedHeight = size ?? height;

  return (
    <svg
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="34" y="9" width="22" height="28" transform="rotate(90 34 9)" stroke="currentColor" strokeWidth="2.5" />
      <path d="M6 16L20 22L34 16" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
    </svg>
  );
};
// 设置图标
export const SettingsIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_settings)">
      <path
        d="M35.4165 11.5719V28.4274L19.9995 36.9059L4.5835 28.4264V11.5719L19.9995 3.09338L35.4165 11.5719Z"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <circle cx="20.0002" cy="19.9999" r="5.41667" stroke="currentColor" strokeWidth="2.5" />
    </g>
    <defs>
      <clipPath id="clip0_settings">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// 关于图标
export const AboutIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="20.0002" cy="20" r="15.4167" stroke="currentColor" strokeWidth="2.5" />
    <rect x="18.75" y="25.8334" width="2.5" height="2.5" fill="currentColor" />
    <rect x="18.75" y="10.8334" width="2.5" height="11.6667" fill="currentColor" />
  </svg>
);

// 帮助图标
export const HelpIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="20.0002" cy="20" r="15.4167" stroke="currentColor" strokeWidth="2.5" />
    <path
      d="M19.8679 24.8741V22.068C19.8679 21.5959 20.0876 21.1506 20.4624 20.8635L22.8198 19.0572C23.6689 18.4065 24.1668 17.3978 24.1668 16.328V16.25C24.1668 13.9489 22.3013 12.0834 20.0002 12.0834C17.699 12.0834 15.8335 13.9489 15.8335 16.25V18.025"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <path d="M19.8672 26.5796V29.0796" stroke="currentColor" strokeWidth="2.5" />
  </svg>
);

// 登出图标
export const LogoutIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19 6.25H8.875C8.52982 6.25 8.25 6.52982 8.25 6.875V33.125C8.25 33.4702 8.52982 33.75 8.875 33.75H19V36.25H8.875C7.14911 36.25 5.75 34.8509 5.75 33.125V6.875C5.75 5.14911 7.14911 3.75 8.875 3.75H19V6.25ZM32.7861 17.8037C34.0065 19.0241 34.0065 21.0032 32.7861 22.2236L26.498 28.5117L24.7305 26.7441L30.2246 21.25H18V18.75H30.1963L24.7305 13.2842L26.498 11.5156L32.7861 17.8037Z"
      fill="currentColor"
    />
  </svg>
);

// 历史图标
export const HistoryIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.0005 4.58337C28.5147 4.58355 35.4165 11.4861 35.4165 20.0004C35.4163 28.5145 28.5146 35.4162 20.0005 35.4164C11.4862 35.4164 4.58367 28.5146 4.5835 20.0004C4.5835 11.486 11.4861 4.58337 20.0005 4.58337Z"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <path
      d="M20 10.8334V20.8334C20 21.2936 20.3731 21.6667 20.8333 21.6667H26.6667"
      stroke="currentColor"
      strokeWidth="2.5"
    />
  </svg>
);

// 用户头像图标
export const ProfileIcon: React.FC<IconProps> = ({ className, size, width = 48, height = 48 }) => (
  <svg
    width={size || width}
    height={size || height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g opacity="0.8">
      <mask
        id="mask0_profile_white"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="8"
        width="30"
        height="30"
      >
        <rect x="9" y="8" width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_profile_white)">
        <path
          d="M36 40C36 33.3726 30.6274 28 24 28C17.3726 28 12 33.3726 12 40"
          stroke="currentColor"
          strokeWidth="2.5"
        />
      </g>
      <circle cx="24" cy="19" r="7.25" stroke="currentColor" strokeWidth="2.5" />
    </g>
  </svg>
);

// 删除图标
export const DelIcon: React.FC<IconProps> = ({ className: _className, size: _size = 40 }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 15.25V29.5H26V15.25" strokeWidth="3" />
    <path d="M11 14.5H29" strokeWidth="3" />
    <path d="M17 10.75H23" strokeWidth="3" />
  </svg>
);

// 搜索图标
export const SearchIcon: React.FC<IconProps> = ({ className, size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_search_white)">
      <path
        d="M18 8.25C23.3848 8.25 27.75 12.6152 27.75 18C27.75 23.3848 23.3848 27.75 18 27.75C12.6152 27.75 8.25 23.3848 8.25 18C8.25 12.6152 12.6152 8.25 18 8.25Z"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path d="M32 32L25 25" stroke="currentColor" strokeWidth="2.5" />
    </g>
    <defs>
      <clipPath id="clip0_search_white">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// Logo+wetv 图标
export const LogoWetvIcon: React.FC<IconProps> = ({ className, width = 308, height = 80 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 308 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M84.6857 47.9313C90.3943 41.9942 89.6972 36.4799 84.6457 31.7428C77.12 24.6856 68.2057 18.9942 58.9429 13.6685C49.72 8.36562 40.2229 4.02848 30.5429 0.611337C24.3771 -1.56581 17.7257 2.27991 16.5314 8.70848C14.64 18.8799 13.6514 29.3713 13.6514 40.0913C13.6514 50.8113 14.6286 61.1656 16.4971 71.2799C17.6857 77.7313 24.3771 81.577 30.5543 79.3713C40.3829 75.8628 50.0286 71.3999 59.3714 65.9428C68.4971 60.6171 77.6171 55.2799 84.6857 47.9256V47.9313Z"
      fill="url(#paint0_linear_6331_23875)"
    />
    <path
      d="M16.4171 9.29139C16.16 9.21139 15.8971 9.12568 15.64 9.05139C9.93715 7.34282 4.92572 9.29139 2.66858 15.4C-0.159995 23.0628 4.74195e-06 31.6 4.74195e-06 40.0114C4.74195e-06 48.4228 -0.0399952 56.8057 2.63429 64.4628C5.09143 71.5085 9.92572 72.5371 15.64 70.8057C15.8857 70.7314 16.1314 70.6514 16.3771 70.5771C14.5886 60.6685 13.6457 50.4571 13.6457 40.0285C13.6457 29.6 14.5943 19.2628 16.4114 9.29139H16.4171Z"
      fill="url(#paint1_linear_6331_23875)"
    />
    <path
      d="M16.4171 9.35938C14.6057 19.3308 13.6514 29.5994 13.6514 40.0965C13.6514 50.5937 14.5886 60.7308 16.3829 70.6451C25.2229 67.9308 33.9029 64.5079 42.3143 60.3479C50.76 56.1708 58.8114 51.7422 65.7429 46.2222C70.9143 42.0965 70.4114 37.3194 65.7029 33.5308C58.72 27.9137 50.4914 23.5365 41.9143 19.3594C33.6343 15.3251 25.1029 12.0108 16.4171 9.36509V9.35938Z"
      fill="url(#paint2_linear_6331_23875)"
    />
    <path
      d="M24.8972 27.3596C24.8972 27.3596 24.4058 28.6339 24.4058 39.9539C24.4058 51.2739 24.8972 52.6625 24.8972 52.6625C25.1886 54.0511 25.8 54.5139 27.3315 54.1654C27.3315 54.1654 29.8858 53.7711 40.1658 48.6054C50.4458 43.4396 52.1658 41.5196 52.1658 41.5196C53.2801 40.4282 53.56 39.7082 52.1658 38.5139C52.1658 38.5139 49.3486 35.9368 40.1715 31.2625C31.0915 26.6339 27.3315 25.8625 27.3315 25.8625C26.0572 25.4968 25.2515 25.8968 24.8972 27.3654V27.3596Z"
      fill="url(#paint3_linear_6331_23875)"
    />
    <path
      d="M111.886 15.6571H119.331C120.497 15.6571 121.48 16.5371 121.606 17.6971L124.891 48.1599H125.034L139.6 16.9714C139.977 16.1657 140.783 15.6514 141.669 15.6514H148.674C149.783 15.6514 150.731 16.4457 150.926 17.5428L156.463 49.0171H156.606L169.211 17.0971C169.554 16.2228 170.4 15.6514 171.337 15.6514H177.617C179.263 15.6514 180.366 17.3371 179.714 18.8457L159.783 64.9657C159.423 65.7999 158.594 66.3428 157.686 66.3428H151.149C150.04 66.3428 149.097 65.5485 148.897 64.4628L142.937 31.2628H142.794L127.366 65.0114C126.994 65.8228 126.183 66.3485 125.286 66.3485H119.114C117.989 66.3485 117.029 65.5314 116.857 64.4171L109.629 18.2971C109.411 16.9085 110.486 15.6571 111.886 15.6571Z"
      fill="white"
    />
    <path
      d="M206.96 58.7027C208.08 59.6227 208.063 61.3198 206.949 62.2513C205.4 63.5427 203.669 64.5998 201.754 65.417C198.96 66.6113 196.16 67.2055 193.343 67.2055C190.526 67.2055 188.211 66.777 185.966 65.9141C183.72 65.057 181.851 63.8284 180.343 62.2284C178.84 60.6284 177.743 58.7084 177.051 56.4627C176.36 54.2227 176.206 51.7141 176.589 48.9427C176.971 46.177 177.817 43.6684 179.131 41.4227C180.446 39.1827 182.08 37.257 184.034 35.657C185.989 34.057 188.211 32.8284 190.691 31.9713C193.171 31.1141 195.749 30.6855 198.423 30.6855C200.903 30.6855 203.103 31.1141 205.011 31.9713C206.92 32.8284 208.474 34.0627 209.663 35.657C212.943 40.0513 212.966 46.0284 211.966 51.1827C211.84 51.8284 211.269 52.297 210.611 52.297C208.589 52.297 204.32 52.297 201.874 52.297H191.606C190.011 52.297 188.417 52.297 186.823 52.297C186.966 54.3484 187.669 55.9827 188.937 57.1998C190.2 58.417 191.886 59.0284 193.983 59.0284C195.749 59.0284 197.286 58.6341 198.6 57.8455C199.389 57.3713 200.143 56.817 200.857 56.177C201.691 55.4284 202.949 55.4055 203.817 56.1141L206.954 58.6855L206.96 58.7027ZM202.006 45.0113C202.291 43.1998 201.909 41.6455 200.863 40.3598C199.811 39.0684 198.309 38.4284 196.354 38.4284C195.16 38.4284 194.086 38.617 193.131 38.9998C192.177 39.3827 191.343 39.8741 190.623 40.4684C189.909 41.0684 189.309 41.7598 188.834 42.5427C188.354 43.3313 188.023 44.1541 187.834 45.0113H202.011H202.006Z"
      fill="white"
    />
    <path
      d="M230.366 25.5362H218.526C217.137 25.5362 216.074 24.3134 216.263 22.9362L216.994 17.6277C217.149 16.4963 218.114 15.6562 219.257 15.6562H254.737C256.126 15.6562 257.189 16.8791 257 18.2563L256.269 23.5648C256.114 24.6963 255.149 25.5362 254.006 25.5362H241.537L236.086 64.3762C235.926 65.502 234.96 66.342 233.823 66.342H227.269C225.88 66.342 224.811 65.1134 225.006 63.7362L230.366 25.5305V25.5362Z"
      fill="white"
    />
    <path
      d="M262.097 15.6562H270.08C271.137 15.6562 272.057 16.382 272.303 17.4162L279.76 48.8791H279.903L296.657 16.8848C297.051 16.1305 297.834 15.662 298.68 15.662H305.383C307.126 15.662 308.223 17.5305 307.383 19.0505L281.914 65.1705C281.514 65.8963 280.743 66.3534 279.914 66.3534H274.08C273.04 66.3534 272.131 65.6505 271.869 64.6448L259.88 18.5248C259.503 17.0791 260.594 15.662 262.091 15.662L262.097 15.6562Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6331_23875"
        x1="33.9771"
        y1="-3.93152"
        x2="57.0457"
        y2="69.0342"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#58CAFF" />
        <stop offset="1" stopColor="#0083F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6331_23875"
        x1="9.62858"
        y1="58"
        x2="7.45143"
        y2="12.0514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7105" />
        <stop offset="1" stopColor="#FFBB00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6331_23875"
        x1="23.7371"
        y1="72.7079"
        x2="48.0571"
        y2="12.5022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#61BA09" />
        <stop offset="1" stopColor="#B5FF25" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6331_23875"
        x1="39.7315"
        y1="50.7768"
        x2="35.2572"
        y2="23.4739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5F6D2" />
        <stop offset="0.52" stopColor="#F8FAFC" />
      </linearGradient>
    </defs>
  </svg>
);
// Logo+Tencent Video 图标
export const TencentVideoIcon: React.FC<IconProps> = ({ className, width = 603, height = 80 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 603 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M126.028 25.1921H113.747C112.209 25.1921 111.034 23.8172 111.278 22.2985L112.216 16.38C112.359 15.4676 113.147 14.7988 114.066 14.7988H152.439C153.589 14.7988 154.47 15.8301 154.289 16.9675L153.32 23.0797C153.126 24.2922 152.083 25.186 150.852 25.186H137.777L131.29 66.0029C131.096 67.2154 130.052 68.1091 128.821 68.1091H121.403C120.253 68.1091 119.372 67.0779 119.553 65.9405L126.028 25.186V25.1921Z"
      fill="white"
    />
    <path
      d="M176.363 60.4538C177.263 61.1975 177.257 62.5662 176.375 63.3349C174.569 64.9099 172.538 66.1785 170.269 67.141C167.307 68.3972 164.345 69.0222 161.388 69.0222C158.432 69.0222 156.001 68.5722 153.658 67.666C151.314 66.7598 149.364 65.4723 147.795 63.7849C146.227 62.1037 145.108 60.0851 144.427 57.7227C143.745 55.3665 143.639 52.7291 144.102 49.8167C144.564 46.9044 145.508 44.2732 146.939 41.9108C148.37 39.5547 150.133 37.5298 152.233 35.8486C154.333 34.1674 156.695 32.8738 159.326 31.9675C161.957 31.0613 164.676 30.6113 167.488 30.6113C170.101 30.6113 172.401 31.0613 174.388 31.9675C176.375 32.8738 177.982 34.1612 179.194 35.8486C180.406 37.5298 181.231 39.5484 181.656 41.9108C182.081 44.2732 182.069 46.9044 181.606 49.8167L181.381 51.248C181.188 52.4604 180.144 53.3541 178.913 53.3541H154.845C154.951 55.5103 155.657 57.2352 156.964 58.5101C158.264 59.7913 160.02 60.4288 162.232 60.4288C164.088 60.4288 165.726 60.0163 167.138 59.1851C167.969 58.6976 168.757 58.1289 169.501 57.4789C170.426 56.6727 171.794 56.6477 172.738 57.4352L176.369 60.4538H176.363ZM170.969 45.6732C171.319 43.767 170.957 42.1358 169.863 40.7797C168.776 39.4235 167.201 38.7485 165.138 38.7485C163.882 38.7485 162.745 38.9485 161.726 39.3484C160.707 39.7484 159.814 40.2671 159.032 40.8921C158.257 41.5233 157.614 42.2484 157.107 43.0733C156.601 43.9046 156.245 44.767 156.057 45.6732H170.969Z"
      fill="white"
    />
    <path
      d="M193.5 31.5171H200.012C201.162 31.5171 202.043 32.5484 201.862 33.6858L201.418 36.4857H201.568C202.03 35.7857 202.643 35.0795 203.412 34.3795C204.174 33.6796 205.055 33.0483 206.043 32.4984C207.036 31.9484 208.136 31.4921 209.349 31.1421C210.561 30.7922 211.843 30.6172 213.199 30.6172C216.061 30.6172 218.299 31.0547 219.917 31.9359C221.536 32.8171 222.711 34.0295 223.442 35.5857C224.173 37.1419 224.548 38.9731 224.567 41.0855C224.579 43.1917 224.398 45.479 224.005 47.9352L221.136 66.0094C220.942 67.2219 219.898 68.1156 218.667 68.1156H211.705C210.555 68.1156 209.674 67.0844 209.855 65.9469L212.355 50.1913C212.524 49.1351 212.661 48.0477 212.761 46.9165C212.867 45.7853 212.805 44.7478 212.58 43.7916C212.355 42.8354 211.899 42.0604 211.218 41.4542C210.536 40.8542 209.468 40.548 208.011 40.548C206.555 40.548 205.337 40.8105 204.349 41.3355C203.362 41.8605 202.555 42.5667 201.943 43.4417C201.324 44.3229 200.855 45.3103 200.53 46.4165C200.206 47.5227 199.943 48.6726 199.756 49.8788L197.193 65.9969C196.999 67.2094 195.956 68.1031 194.725 68.1031H187.762C186.612 68.1031 185.731 67.0719 185.912 65.9344L191.05 33.6171C191.243 32.4046 192.287 31.5109 193.518 31.5109L193.5 31.5171Z"
      fill="white"
    />
    <path
      d="M259.334 41.6727C258.447 42.4727 257.116 42.5415 256.166 41.8103C255.953 41.6416 255.716 41.4916 255.466 41.3416C254.547 40.8166 253.51 40.5541 252.353 40.5541C249.491 40.5541 247.135 41.4103 245.285 43.1165C243.435 44.8226 242.285 47.06 241.848 49.8162C241.41 52.5785 241.848 54.8097 243.154 56.5159C244.466 58.222 246.547 59.0783 249.41 59.0783C250.666 59.0783 251.791 58.8033 252.778 58.2471C253.216 58.0033 253.635 57.7346 254.034 57.4533C254.853 56.8658 255.991 57.0034 256.616 57.7908L260.059 62.1344C260.953 63.2656 260.728 64.9468 259.528 65.7405C258.059 66.7092 256.491 67.4404 254.822 67.9216C252.322 68.6466 249.991 69.0153 247.835 69.0153C245.022 69.0153 242.447 68.5654 240.104 67.6592C237.76 66.753 235.81 65.4656 234.242 63.7781C232.673 62.0969 231.554 60.0782 230.873 57.7158C230.192 55.3597 230.086 52.7223 230.548 49.8099C231.01 46.8975 231.954 44.2665 233.385 41.9041C234.817 39.5479 236.579 37.523 238.679 35.8418C240.779 34.1606 243.141 32.8669 245.772 31.9607C248.403 31.0545 251.122 30.6045 253.935 30.6045C256.091 30.6045 258.309 30.967 260.578 31.6982C262.159 32.2044 263.547 32.9732 264.734 34.0044C265.578 34.7356 265.572 36.0543 264.734 36.8043L259.334 41.6666V41.6727Z"
      fill="white"
    />
    <path
      d="M297.276 59.9788C298.476 60.9725 298.501 62.8287 297.295 63.8162C295.633 65.1724 293.789 66.2785 291.764 67.141C288.802 68.3972 285.839 69.0222 282.883 69.0222C279.927 69.0222 277.496 68.5722 275.152 67.666C272.809 66.7598 270.859 65.4723 269.29 63.7849C267.722 62.1037 266.603 60.0851 265.922 57.7227C265.24 55.3665 265.134 52.7291 265.597 49.8167C266.059 46.9044 267.003 44.2732 268.434 41.9108C269.865 39.5547 271.628 37.5298 273.727 35.8486C275.827 34.1674 278.19 32.8738 280.821 31.9675C283.452 31.0613 286.171 30.6113 288.983 30.6113C291.595 30.6113 293.895 31.0613 295.883 31.9675C297.87 32.8738 299.476 34.1612 300.689 35.8486C301.901 37.5298 302.72 39.5484 303.151 41.9108C303.576 44.2732 303.564 46.9044 303.101 49.8167L302.876 51.248C302.683 52.4604 301.639 53.3541 300.408 53.3541H276.34C276.446 55.5103 277.152 57.2352 278.459 58.5101C279.758 59.7913 281.515 60.4288 283.727 60.4288C285.583 60.4288 287.221 60.0163 288.633 59.1851C289.583 58.6289 290.483 57.9602 291.321 57.1852C292.02 56.5352 293.083 56.479 293.82 57.0852L297.295 59.9663L297.276 59.9788ZM292.458 45.6732C292.808 43.767 292.445 42.1358 291.352 40.7797C290.258 39.4235 288.689 38.7485 286.627 38.7485C285.371 38.7485 284.233 38.9485 283.215 39.3484C282.196 39.7484 281.302 40.2671 280.521 40.8921C279.746 41.5233 279.102 42.2484 278.596 43.0733C278.09 43.9046 277.734 44.767 277.546 45.6732H292.458Z"
      fill="white"
    />
    <path
      d="M314.988 31.5171H321.501C322.65 31.5171 323.532 32.5484 323.35 33.6858L322.907 36.4857H323.057C323.519 35.7857 324.132 35.0795 324.9 34.3795C325.663 33.6796 326.544 33.0483 327.532 32.4984C328.525 31.9484 329.625 31.4921 330.838 31.1421C332.05 30.7922 333.331 30.6172 334.688 30.6172C337.55 30.6172 339.787 31.0547 341.406 31.9359C343.025 32.8171 344.2 34.0295 344.931 35.5857C345.662 37.1419 346.037 38.9731 346.056 41.0855C346.068 43.1917 345.887 45.479 345.493 47.9352L342.625 66.0094C342.431 67.2219 341.387 68.1156 340.156 68.1156H333.194C332.044 68.1156 331.163 67.0844 331.344 65.9469L333.844 50.1913C334.013 49.1351 334.15 48.0477 334.25 46.9165C334.356 45.7853 334.294 44.7478 334.069 43.7916C333.844 42.8354 333.388 42.0604 332.706 41.4542C332.025 40.8542 330.956 40.548 329.5 40.548C328.044 40.548 326.825 40.8105 325.838 41.3355C324.85 41.8605 324.044 42.5667 323.432 43.4417C322.813 44.3229 322.344 45.3103 322.019 46.4165C321.694 47.5227 321.432 48.6726 321.244 49.8788L318.682 65.9969C318.488 67.2094 317.444 68.1031 316.213 68.1031H309.251C308.101 68.1031 307.22 67.0719 307.401 65.9344L312.538 33.6171C312.732 32.4046 313.776 31.5109 315.007 31.5109L314.988 31.5171Z"
      fill="white"
    />
    <path
      d="M377.967 40.5535H369.63L367.692 52.753C367.53 53.7592 367.436 54.6716 367.405 55.5028C367.374 56.334 367.486 57.0465 367.742 57.6465C367.999 58.2465 368.461 58.7152 369.142 59.0402C369.817 59.3651 370.761 59.5277 371.961 59.5277C372.561 59.5277 373.361 59.4651 374.361 59.3401C374.373 59.3401 374.38 59.3401 374.392 59.3401C375.504 59.1964 376.461 60.1214 376.286 61.2338L375.411 66.7336C375.292 67.4648 374.761 68.0585 374.048 68.2523C373.098 68.5085 372.142 68.6897 371.167 68.796C369.786 68.946 368.442 69.021 367.142 69.021C365.236 69.021 363.511 68.821 361.968 68.421C360.424 68.021 359.118 67.3773 358.055 66.5024C356.987 65.6274 356.23 64.4837 355.774 63.0775C355.318 61.6713 355.255 59.9651 355.574 57.959L358.336 40.566H354.037C352.499 40.566 351.324 39.191 351.568 37.6724L352.293 33.11C352.437 32.1976 353.224 31.5288 354.143 31.5288H359.774L361.161 22.7917C361.355 21.5793 362.399 20.6855 363.63 20.6855H370.592C371.742 20.6855 372.623 21.7167 372.442 22.8542L371.067 31.5288H378.079C379.617 31.5288 380.792 32.9038 380.548 34.4224L379.823 38.9848C379.679 39.8972 378.892 40.566 377.973 40.566L377.967 40.5535Z"
      fill="white"
    />
    <path
      d="M402.71 14.7988H411.722C412.897 14.7988 413.915 15.6176 414.165 16.7675L421.365 49.7411H421.515L439.939 15.7801C440.264 15.1739 440.902 14.7988 441.589 14.7988H448.739C450.658 14.7988 451.864 16.8738 450.908 18.5362L423.309 66.8529C422.865 67.6341 422.034 68.1153 421.14 68.1153H414.653C413.784 68.1153 413.034 67.5216 412.828 66.6779L400.891 17.1113C400.61 15.9301 401.503 14.7988 402.716 14.7988H402.71Z"
      fill="white"
    />
    <path
      d="M457.032 31.5171H463.801C465.338 31.5171 466.513 32.8921 466.269 34.4108L461.251 66.0095C461.057 67.2219 460.013 68.1156 458.782 68.1156H451.82C450.67 68.1156 449.789 67.0844 449.97 65.947L455.189 33.0983C455.332 32.1859 456.12 31.5171 457.038 31.5171H457.032ZM456.357 19.9989C456.645 18.1928 457.532 16.649 459.013 15.3679C460.495 14.0867 462.144 13.4492 463.951 13.4492C465.757 13.4492 467.201 14.0867 468.275 15.3679C469.35 16.649 469.75 18.1928 469.463 19.9989C469.175 21.8051 468.288 23.3488 466.807 24.63C465.326 25.9112 463.676 26.5486 461.87 26.5486C460.063 26.5486 458.62 25.9112 457.545 24.63C456.47 23.3488 456.07 21.8051 456.357 19.9989Z"
      fill="white"
    />
    <path
      d="M505.311 68.1151H499.249C498.099 68.1151 497.218 67.084 497.399 65.9465L497.818 63.2966H497.668C497.112 63.9466 496.418 64.6153 495.58 65.2903C494.743 65.9652 493.793 66.584 492.724 67.134C491.656 67.6839 490.506 68.1401 489.268 68.4901C488.031 68.8401 486.787 69.0151 485.531 69.0151C482.818 69.0151 480.431 68.5526 478.375 67.6214C476.312 66.6964 474.625 65.3902 473.313 63.7028C472 62.0216 471.1 60.028 470.613 57.7156C470.125 55.4094 470.1 52.872 470.538 50.1096C470.944 47.5472 471.725 45.1036 472.869 42.7662C474.019 40.435 475.45 38.3602 477.169 36.554C478.887 34.7478 480.862 33.3041 483.087 32.2229C485.318 31.1417 487.737 30.6042 490.349 30.6042C492.705 30.6042 494.849 30.9667 496.768 31.6979C498.686 32.4292 500.155 33.6666 501.18 35.4228H501.33L504.93 12.755C505.074 11.8426 505.861 11.1738 506.78 11.1738H513.548C515.086 11.1738 516.261 12.5488 516.017 14.0675L507.767 65.9965C507.574 67.2089 506.53 68.1026 505.299 68.1026L505.311 68.1151ZM499.961 49.8159C500.399 47.0535 499.961 44.8224 498.655 43.1162C497.343 41.41 495.262 40.5538 492.399 40.5538C489.537 40.5538 487.181 41.41 485.331 43.1162C483.481 44.8224 482.331 47.0598 481.893 49.8159C481.456 52.5783 481.893 54.8094 483.2 56.5156C484.512 58.2218 486.593 59.0781 489.456 59.0781C492.318 59.0781 494.674 58.228 496.524 56.5156C498.374 54.8094 499.524 52.5783 499.961 49.8159Z"
      fill="white"
    />
    <path
      d="M549.941 59.9788C551.141 60.9725 551.166 62.8287 549.959 63.8162C548.297 65.1724 546.453 66.2785 544.428 67.141C541.466 68.3972 538.504 69.0222 535.547 69.0222C532.591 69.0222 530.16 68.5722 527.817 67.666C525.473 66.7598 523.523 65.4723 521.954 63.7849C520.386 62.1037 519.267 60.0851 518.586 57.7227C517.904 55.3665 517.798 52.7291 518.261 49.8167C518.723 46.9044 519.667 44.2732 521.098 41.9108C522.529 39.5547 524.292 37.5298 526.392 35.8486C528.491 34.1674 530.854 32.8738 533.485 31.9675C536.116 31.0613 538.835 30.6113 541.647 30.6113C544.26 30.6113 546.559 31.0613 548.547 31.9675C550.534 32.8738 552.14 34.1612 553.353 35.8486C554.565 37.5298 555.39 39.5484 555.815 41.9108C556.24 44.2732 556.228 46.9044 555.765 49.8167L555.54 51.248C555.347 52.4604 554.303 53.3541 553.072 53.3541H529.004C529.11 55.5103 529.816 57.2352 531.123 58.5101C532.423 59.7913 534.179 60.4288 536.391 60.4288C538.247 60.4288 539.885 60.0163 541.297 59.1851C542.247 58.6289 543.147 57.9602 543.985 57.1852C544.685 56.5352 545.747 56.479 546.484 57.0852L549.959 59.9663L549.941 59.9788ZM545.128 45.6732C545.478 43.767 545.11 42.1358 544.022 40.7797C542.928 39.4235 541.36 38.7485 539.297 38.7485C538.041 38.7485 536.904 38.9485 535.885 39.3484C534.866 39.7484 533.972 40.2671 533.191 40.8921C532.416 41.5233 531.773 42.2484 531.266 43.0733C530.76 43.9046 530.404 44.767 530.216 45.6732H545.128Z"
      fill="white"
    />
    <path
      d="M561.259 49.8167C561.721 46.9044 562.665 44.2732 564.096 41.9108C565.528 39.5547 567.29 37.5298 569.39 35.8486C571.49 34.1674 573.852 32.8738 576.483 31.9675C579.114 31.0613 581.833 30.6113 584.645 30.6113C587.458 30.6113 590.033 31.0613 592.376 31.9675C594.72 32.8738 596.67 34.1612 598.239 35.8486C599.801 37.5298 600.926 39.5484 601.607 41.9108C602.288 44.2732 602.395 46.9044 601.932 49.8167C601.47 52.7291 600.526 55.3665 599.095 57.7227C597.664 60.0851 595.901 62.1037 593.801 63.7849C591.701 65.4661 589.339 66.7598 586.708 67.666C584.077 68.5722 581.358 69.0222 578.546 69.0222C575.733 69.0222 573.158 68.5722 570.815 67.666C568.471 66.7598 566.521 65.4723 564.953 63.7849C563.384 62.1037 562.265 60.0851 561.584 57.7227C560.903 55.3665 560.796 52.7291 561.259 49.8167ZM572.552 49.8167C572.115 52.5791 572.552 54.8103 573.858 56.5164C575.171 58.2226 577.252 59.0789 580.114 59.0789C582.977 59.0789 585.333 58.2289 587.183 56.5164C589.033 54.8103 590.183 52.5791 590.62 49.8167C591.058 47.0544 590.62 44.8232 589.314 43.1171C588.002 41.4109 585.92 40.5547 583.058 40.5547C580.196 40.5547 577.84 41.4109 575.99 43.1171C574.14 44.8232 572.99 47.0606 572.552 49.8167Z"
      fill="white"
    />
    <path
      d="M84.6792 47.9219C90.3853 41.9847 89.6853 36.4725 84.6355 31.7352C77.1108 24.6792 68.1987 18.9857 58.9304 13.6609C49.7182 8.36737 40.2124 4.02381 30.5378 0.61145C24.3756 -1.56346 17.7196 2.2801 16.5259 8.71108C14.6322 18.8857 13.6448 29.3728 13.6448 40.0973C13.6448 50.8219 14.6197 61.1714 16.4884 71.2834C17.6821 77.7332 24.3693 81.5768 30.5441 79.3769C40.3749 75.8708 50.0182 71.4022 59.3616 65.9525C68.4862 60.6277 77.6045 55.2904 84.6792 47.9344V47.9219Z"
      fill="url(#paint0_linear_12123_31538)"
    />
    <path
      d="M16.4133 9.28685C16.1509 9.20561 15.8946 9.12435 15.6384 9.0431C9.93238 7.33693 4.92634 9.28686 2.67019 15.3929C-0.154691 23.055 0.00154993 31.5922 0.00154993 39.9981C0.00154993 48.4039 -0.0359538 56.7911 2.63268 64.4533C5.08883 71.4967 9.92613 72.5279 15.6384 70.7968C15.8821 70.7218 16.1321 70.6405 16.3758 70.5655C14.5822 60.6534 13.6447 50.4476 13.6447 40.0231C13.6447 29.5985 14.5947 19.2552 16.4071 9.28685H16.4133Z"
      fill="url(#paint1_linear_12123_31538)"
    />
    <path
      d="M16.4133 9.34903C14.6008 19.3174 13.6509 29.5919 13.6509 40.0853C13.6509 50.5786 14.5883 60.7219 16.382 70.6277C25.2254 67.9091 33.9 64.4905 42.3122 60.3344C50.7556 56.1596 58.8115 51.7285 65.7362 46.2037C70.911 42.0789 70.4047 37.3041 65.6987 33.5105C58.7115 27.892 50.4868 23.5109 41.9122 19.3361C33.6313 15.305 25.1004 11.9864 16.4195 9.34277L16.4133 9.34903Z"
      fill="url(#paint2_linear_12123_31538)"
    />
    <path
      d="M24.8942 27.3481C24.8942 27.3481 24.4067 28.623 24.4067 39.9413C24.4067 51.2596 24.8942 52.647 24.8942 52.647C25.1817 54.0344 25.8004 54.4969 27.3254 54.1469C27.3254 54.1469 29.8815 53.7532 40.1561 48.5847C50.4369 43.4161 52.1556 41.4975 52.1556 41.4975C53.268 40.4038 53.5493 39.685 52.1556 38.4976C52.1556 38.4976 49.3369 35.9227 40.1623 31.2479C31.0815 26.6231 27.3254 25.8481 27.3254 25.8481C26.0504 25.4856 25.2442 25.8856 24.8942 27.3481Z"
      fill="url(#paint3_linear_12123_31538)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12123_31538"
        x1="-133.393"
        y1="-3.93836"
        x2="-132.768"
        y2="69.0273"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#58CAFF" />
        <stop offset="1" stopColor="#0083F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12123_31538"
        x1="9.62614"
        y1="57.991"
        x2="7.45123"
        y2="12.0492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7105" />
        <stop offset="1" stopColor="#FFBB00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12123_31538"
        x1="23.738"
        y1="72.6964"
        x2="48.0494"
        y2="12.4989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#61BA09" />
        <stop offset="1" stopColor="#B5FF25" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12123_31538"
        x1="39.7248"
        y1="50.7658"
        x2="35.2563"
        y2="23.467"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5F6D2" />
        <stop offset="0.52" stopColor="#F8FAFC" />
      </linearGradient>
    </defs>
  </svg>
);
// Logo 图标
export const LogoIcon: React.FC<IconProps> = ({ className, size, width = 45, height = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 45 40"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <g clipPath="url(#clip0_logo)">
      <path
        d="M42.3415 23.963C45.1938 20.9968 44.8462 18.2368 42.32 15.8707C38.5569 12.3414 34.1015 9.49529 29.4677 6.83068C24.8585 4.18452 20.1077 2.01529 15.2708 0.304523C12.1877 -0.78163 8.86154 1.14145 8.26462 4.35375C7.32 9.44299 6.82462 14.6861 6.82462 20.0491C6.82462 25.4122 7.31077 30.5845 8.24615 35.643C8.84 38.8676 12.1877 40.7907 15.2738 39.6861C20.1877 37.9322 25.0123 35.7014 29.6831 32.9753C34.2462 30.3107 38.8062 27.643 42.3415 23.963Z"
        fill="url(#paint0_linear_logo)"
      />
      <path
        d="M8.20616 4.64613C8.07693 4.60613 7.9477 4.56306 7.81847 4.52613C4.96616 3.67075 2.45847 4.64613 1.33231 7.70152C-0.0799957 11.5323 4.45562e-06 15.8 4.45562e-06 20.0031C4.45562e-06 24.2061 -0.021534 28.4 1.31693 32.2307C2.54462 35.7538 4.96308 36.2677 7.81847 35.4031C7.94154 35.3661 8.06462 35.3261 8.1877 35.2892C7.29231 30.3323 6.82462 25.2277 6.82462 20.0154C6.82462 14.8031 7.29847 9.63075 8.20616 4.64613Z"
        fill="url(#paint1_linear_logo)"
      />
      <path
        d="M8.20615 4.67969C7.29846 9.6643 6.82462 14.7997 6.82462 20.0489C6.82462 25.2982 7.29231 30.3658 8.18769 35.3197C12.6092 33.9628 16.9477 32.252 21.1538 30.172C25.3754 28.0828 29.4031 25.8674 32.8677 23.1074C35.4554 21.0458 35.2031 18.6551 32.8492 16.7628C29.3569 13.9505 25.2431 11.7628 20.9538 9.67661C16.8154 7.65815 12.5477 5.99969 8.20615 4.67969Z"
        fill="url(#paint2_linear_logo)"
      />
      <path
        d="M12.4462 13.6802C12.4462 13.6802 12.2031 14.3141 12.2031 19.9756C12.2031 25.6372 12.4462 26.3295 12.4462 26.3295C12.5908 27.0248 12.8985 27.2556 13.6615 27.0802C13.6615 27.0802 14.9385 26.8833 20.08 24.2987C25.2185 21.7141 26.08 20.7541 26.08 20.7541C26.6338 20.2095 26.7754 19.8464 26.08 19.2525C26.08 19.2525 24.6708 17.9664 20.0831 15.6279C15.5415 13.3141 13.6646 12.9295 13.6646 12.9295C13.0246 12.7479 12.6215 12.9448 12.4462 13.6802Z"
        fill="url(#paint3_linear_logo)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_logo"
        x1="16.0615"
        y1="-2.90163"
        x2="29.0338"
        y2="35.5968"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#58CAFF" />
        <stop offset="1" stopColor="#0083F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_logo"
        x1="6.6"
        y1="29.1538"
        x2="2.34154"
        y2="5.79998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7105" />
        <stop offset="1" stopColor="#FFBB00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_logo"
        x1="10.3631"
        y1="37.6458"
        x2="24.9754"
        y2="4.71353"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#61BA09" />
        <stop offset="1" stopColor="#B5FF25" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_logo"
        x1="19.8769"
        y1="25.4772"
        x2="17.6246"
        y2="11.6464"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5F6D2" />
        <stop offset="0.52" stopColor="#F8FAFC" />
      </linearGradient>
      <clipPath id="clip0_logo">
        <rect width="44.3508" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// VIP 角标图标 - 用于头像右下角
export const VipBadgeIcon: React.FC<VipBadgeIconProps> = ({ className, width = 34, height = 20, expired = false }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="34" height="20" rx="4" fill={expired ? '#F0F2F7' : 'url(#vip_badge_gradient)'} />
    <text x="17" y="14" textAnchor="middle" fill={expired ? '#919499' : '#4A2800'} fontSize="11" fontWeight="700">
      VIP
    </text>
    {!expired && (
      <defs>
        <linearGradient id="vip_badge_gradient" x1="0" y1="0" x2="34" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE5A0" />
          <stop offset="1" stopColor="#F9C94B" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

// VIP Item 角标图标 - 用于播放控制栏清晰度选项
export const VipItemBadgeIcon: React.FC<VipBadgeIconProps> = ({ className, width = 40, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ flexShrink: 0 }}
  >
    <g clipPath="url(#vip_item_badge_clip)">
      <rect width="40" height="24" rx="3.42857" fill="#E6EAF2" />
      <rect width="40" height="24" rx="3.42857" fill="url(#vip_item_badge_gradient1)" />
      <rect width="40" height="24" rx="3.42857" fill="url(#vip_item_badge_gradient2)" />
      <rect width="40" height="24" rx="3.42857" fill="#FFD9A7" />
      <path
        d="M11.2327 18.2679L6.42871 5.7168H9.35623V5.88743C8.98765 6.01056 8.84656 6.33424 9.02645 6.83909L12.6188 16.208C12.7864 15.5307 12.9716 14.8201 13.1638 14.083C13.8481 11.4567 14.6152 8.51374 14.9344 5.71856H17.2588L12.5712 18.2696H11.2327V18.2679Z"
        fill="#3C1804"
      />
      <path
        d="M18.8975 18.2344V18.0691C19.1391 18.004 19.2255 17.5994 19.2255 17.0629V6.88659C19.2255 6.35007 19.0738 5.91381 18.8975 5.84873V5.7168H21.6275V5.84873C21.407 5.91381 21.2995 6.35007 21.2995 6.88659V17.0646C21.2995 17.6012 21.407 18.0058 21.6275 18.0708V18.2362H18.8975V18.2344Z"
        fill="#3C1804"
      />
      <path
        d="M24.0195 18.2344V18.0691C24.2417 18.004 24.3476 17.5994 24.3476 17.0629V6.88659C24.3476 6.35007 24.2594 5.87511 24.0195 5.84873V5.7168H27.977C31.7087 5.7168 33.4546 6.9851 33.4546 9.50586C33.4546 12.0266 31.4459 13.5218 27.4691 13.5218H27.201V12.9238H27.4532C30.1867 12.9238 31.3313 11.9545 31.3313 9.58678C31.3313 7.21905 30.3172 6.31489 27.6172 6.31489H26.4233V17.0646C26.4233 17.5906 26.5115 18.0058 26.7513 18.0708V18.2362H24.0213L24.0195 18.2344Z"
        fill="#3C1804"
      />
    </g>
    <defs>
      <linearGradient
        id="vip_item_badge_gradient1"
        x1="-13.8192"
        y1="12"
        x2="120.758"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#D4B68E" />
      </linearGradient>
      <linearGradient
        id="vip_item_badge_gradient2"
        x1="-8.50986e-08"
        y1="10.5882"
        x2="40.0346"
        y2="10.5882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFAF2" />
        <stop offset="1" stopColor="#F2E7DA" />
      </linearGradient>
      <clipPath id="vip_item_badge_clip">
        <rect width="40" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// VIP Item 角标图标 - 用于设置页面1080p切换
export const VipItemSettingIcon: React.FC<VipBadgeIconProps> = ({ className, width = 40, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="40" height="24" rx="1.6" fill="#F9DD94" />
    <path
      d="M16.404 6.184L12.174 19H10.284L6.054 6.184H8.646L11.238 14.518L13.794 6.184H16.404ZM20.455 6.184V19H17.953V6.184H20.455ZM23.4549 6.184H28.4229C31.0869 6.184 32.6529 8.002 32.6529 10.18C32.6529 12.358 31.0869 14.176 28.4229 14.176H25.9569V19H23.4549V6.184ZM28.2969 8.416H25.9569V11.944H28.2969C29.4309 11.944 30.1509 11.224 30.1509 10.18C30.1509 9.118 29.4309 8.416 28.2969 8.416Z"
      fill="#111111"
    />
  </svg>
);
// ============ 账号类型图标（20x20） ============

// Google 图标
export const GoogleIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18.1713 8.36791H17.5V8.33325H10V11.6666H14.7096C14.0225 13.6071 12.1762 14.9999 10 14.9999C7.23875 14.9999 5 12.7612 5 9.99992C5 7.23867 7.23875 4.99992 10 4.99992C11.2746 4.99992 12.4342 5.48075 13.3171 6.26617L15.6742 3.90909C14.1858 2.52242 12.195 1.66659 10 1.66659C5.39792 1.66659 1.66667 5.39784 1.66667 9.99992C1.66667 14.602 5.39792 18.3333 10 18.3333C14.6021 18.3333 18.3333 14.602 18.3333 9.99992C18.3333 9.44117 18.2758 8.89575 18.1713 8.36791Z"
      fill="#FFC107"
    />
    <path
      d="M2.6275 6.12117L5.36542 8.12909C6.10625 6.29492 7.90042 4.99992 10 4.99992C11.2746 4.99992 12.4342 5.48075 13.3171 6.26617L15.6742 3.90909C14.1858 2.52242 12.195 1.66659 10 1.66659C6.79917 1.66659 4.02333 3.47367 2.6275 6.12117Z"
      fill="#FF3D00"
    />
    <path
      d="M10 18.3333C12.1525 18.3333 14.1083 17.5095 15.5871 16.17L13.0079 13.9875C12.1431 14.6451 11.0864 14.9999 10 14.9999C7.8325 14.9999 5.99208 13.6179 5.29875 11.6891L2.58125 13.7829C3.96042 16.4816 6.76125 18.3333 10 18.3333Z"
      fill="#4CAF50"
    />
    <path
      d="M18.1713 8.36784H17.5V8.33325H10V11.6666H14.7096C14.3809 12.5902 13.7889 13.3972 13.0067 13.9879L13.0079 13.987L15.5871 16.1695C15.4046 16.3353 18.3333 14.1666 18.3333 9.99992C18.3333 9.44117 18.2758 8.89575 18.1713 8.36784Z"
      fill="#1976D2"
    />
  </svg>
);

// Apple 图标
export const AppleIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.3 10.4c0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.6.8-3.3.8s-1.7-.8-2.8-.8c-1.5 0-2.8.9-3.6 2.2-1.5 2.7-.4 6.6 1.1 8.8.7 1.1 1.6 2.3 2.8 2.3 1.1 0 1.5-.7 2.8-.7 1.3 0 1.6.7 2.8.7 1.2 0 2-1.1 2.7-2.2.9-1.3 1.2-2.5 1.2-2.6 0-.1-2.4-.9-2.4-3.4zM13 3.8c.6-.7 1-1.7.9-2.6-.8 0-1.8.5-2.4 1.2-.5.6-1 1.6-.9 2.5.9.1 1.8-.5 2.4-1.1z"
      fill="currentColor"
    />
  </svg>
);

// Facebook 图标
export const FacebookIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="10" cy="10" r="8.5" fill="#1877F2" />
    <path
      d="M12.5 13l.5-3h-3V8.5c0-.8.4-1.5 1.5-1.5H13V4.3s-1-.2-1.9-.2c-2 0-3.3 1.2-3.3 3.4V10H5v3h2.8v7.2c.6.1 1.1.1 1.7.1s1.2 0 1.7-.1V13h2.3z"
      fill="white"
    />
  </svg>
);

// Line 图标
export const LineIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="20" height="20" rx="10" fill="white" />
    <rect width="20" height="20" rx="10" fill="url(#pattern0_5355_100218)" />
    <defs>
      <pattern id="pattern0_5355_100218" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_5355_100218" transform="scale(0.00444444)" />
      </pattern>
      <image
        id="image0_5355_100218"
        width="225"
        height="225"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

// 微信图标
export const WeChatIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="20" height="20" rx="10" fill="white" />
    <rect width="20" height="20" rx="10" fill="url(#pattern0_5355_100221)" />
    <defs>
      <pattern id="pattern0_5355_100221" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_5355_100221" transform="scale(0.00444444)" />
      </pattern>
      <image
        id="image0_5355_100221"
        width="225"
        height="225"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAIAAACx0UUtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA4aADAAQAAAABAAAA4QAAAAAYn8bHAAAb60lEQVR4Ae1dC5gVxZXuvq95My9weA3D24EVCUZwwZUkykNwP8260U0QduMKuBLImohEl7jqR3yDJME1ClF3leAnrsZ1N6CA0WAEQcXAyENgeDM8ZgaGmeHOzH3u37dn+l7us+/trr7V06e/+aBvdXXVOf/5+1TV6apqcUzdowIdhACvCFzhqHDs9J3jVTySixAQegdybQQDIcA5AsRRzg1E4gnEUSIB7wgQR3m3EMlHHCUO8I4AcZR3C5F8xFHiAO8IEEd5txDJ5xCCQUKBEOAZAfKjPFuHZJMQII4SD3hHgDjKu4VIPuIocYB3BIijvFuI5COOEgd4RwCxJ95FJPmsi4AoqU5+1LoEMIvmxFGzWMq6chJHrWt7s2hOHDWLpawrJ3HUurY3i+YOkeaUmMVW1pMzKEoDe/Kj1rO82TQmjprNYtaTlzhqPZubTWPiqNksZj15iaPWs7nZNCaOms1iVpJXDEizSWhOiZVsbjpdaU6J6UxmTYGprbem3c2kNXHUTNaypqzEUWva3UxaE0fNZC1ryuoQQsN7aypPWvOOQGhc7xBC//EuK8lnTQRsNO/JmoY3m9bUHzWbxawnL3HUejY3m8bEUbNZzHryEketZ3MTaUxzSkxkLIuK2hl7spT2XYE2f8dFwREQfDbp30QHroYOe05BZxbadygRVizTHSwL56DsECk7GSkIdlvRlNzK/r6i6l59ezlKKuw98mw5LtGJfwvFHFncDp/Haw9e8Le2BTouBNqOe+vP+S/uaDu231tfKzR2quSzdRKXWMveyN2Ro6KgkHK8c+D1ecNHlw+8PKd/lbNnsT0/NaSdXI2f8VDHmYOeuq86jm1q3bshcNIfaEE+u71Iyk18jY+Z1lTRfnC+1jI4ub+LmuDl9wrHXJs/sjqnnypSapB/78Xjn3sPvd60db13H4ohsmrAMt6tojDF1s/8HO2i5jRn9Z2lE28ouLLMURhPXeZpH1/c827L50vPf4Q+rkRWcqvaIQdHcypF+/4faS8qOyXYRb+/ZYhQ/nCvm28uGsvaZarXEWR94ez7a3w7MSazuwpo1o566KJz2sQpdvhR03HUJvo90qh8juua+RU3XZk7IFoxPn5f8LtfOr9xUfMmdI6JqRnaxIwc9fvc0HZZr1vuKp3Mj+NMboA3L2x58OxbiAkgqkA+NTlW0Vc7OWqSMZPsO5eV/p2J2BmJ+IaWL+edXt3J1MgLdJ4EgdCYyQyxJ4yK/C0LS6//ea/vmcV3xsI+pWjMwaIx8Km31/0WV6XWnw51CPD+vh4ByHG28toBTz3T+x/NS1DFFrcVTwiOeHlx2SQpsNr10ku5SidxEeCYo3CfgZa1l83dMvCRwTkVcaU3aeIvKmbs6btkoN8ldWDoSIJAKH7H6bjeL7Qi3vl65Y+7ge9MYoJnG/7nvrNr7TllNJZKhNIUZ38e/ajfe35V+cx1Ax/o3gSFVX7a85adg58AQeV4RSI7WTedx/VMkMkuwmyzyyZZxDCI7/qGPTctbzjRNJHFOfKjMNI4e3lj1VPchuUTgag9HY0Ggr5oQLQX1f1K4IWj6IDOyB2F4VG3b98TcQjt/tp+PyKaxuLDBUdB0MU9pvxu0E9i5bNUCiJTm6sWE02jjJ59jqKJx9sjhGOiJLPmz+sKRqI7TjTttH5oPVOWOSoRtNctaOasyci4WqM7vqfqSaKpAk42OQqC4o0LEVQxhnIyoqDy04GPEE1lQLLGURAUgyRq4hVeRp1ckz/s/cqFRFPAkjWOjs8bQIOkKF5G/cQ0lGWX3Y6HOSrdaj+zw1Hgvr5ykdWwzkBfdITQ2licplngKNqvrf0WWTYOmi5T0drYHSqWs6ZbrnnyO0S/oWvDfME2tF9/3aPaPBBlX9Kavj8befQBh60k+6IYL4HT2P5o0C6OCpbTQD5dQ2OYjwcbj3e6N5o9PwgDFQydh+/vaHpn2EMsgMM695dbPvxl0zaf7wLKH5JTMa904veLJ/Z1lrKoTilz9ZkPfnPhoy3+k0KwQwjkTCscfm/5VIx1lAx6neDBfv785iNCh8Htnl7yaylHdOydp+V+9ffCDSAayiLYNPfob1Zd/DMoYs/Jl02I508aZwQ7VpT8w/y+N6sXUn3OXe3Hrjr+NGqRO4uoV37o8RziCdkwYJHu87JR4+hDD1qqxQekxs0fleznF1gQdMKRR1a5P4PlHI48xcfgxCHmIXHBubX3n35VPfNU5sQKetAFmVEL6pLrlU8cjmJ4uyG1P8WuOypLU5kN75/mFPyNz2e5Ft+gcT38zdrK2SqNoT4bPOjWtmMgSqJbwJilDRuw0i1RhgzSz/laJx59zO4slakZWwLScXXIAYnE+h5P9psl2Dr0LZP/0gziKGiEST36wgFHhSY+CUHl6kBTeSmmXrU/cPI19CsSEVSuRbpqF7AURK9K5XKwTdDi8pus40plkI3gKHqia/rcoa+1UNrLTR+AKyqLxfJ2lTmTZ8PuI6taPkG/Ink2XMXD87OGDSmzpZvh/p7ftZorNYKj6Inq7kRh2ncbv1TDFYkEfmHjxZp02RA3/672I3HT4yb6Ak2690rx7mNh2VTruFIAy5yjUtC+N5OpdzWBrh1r4xIkIhFU3t1eF5GQ+elpX5MguNTeL+bU+5vVZlad75+LviMIHtXZTZ+ROUcFvwdxShY4qXWigqCz17Gr1sbvwQ7RqnOrzYiQ/vjCoWpzmz8fc45OK7yCUSB9nK1MPf7jhP7qMyfJif2g8dQlyXDJJVuwvyMNIS+5N+mPeXnX6fzgJa0uuxfZchQNPfatZaThnT2/pdpOnhvLrtZFjNCaVbVt/SihL6MNe6eXX2Od5p4tR+FysLGyLuSILSQ0DlPl0kbZ+ug4i2VF2Xfx7MXKE5WCt7JLK2dEJer1E9Sf4BqkV2mcl8OWo+g2MXIkgBUj3LWV8zB2Tg4xMrxR9ePkedK6iperQxylyV04rqKTw+LFvSJqOs2IcpMpTxhyFHbCtxOYogJXKk0ISkxTXMKKCwwy9BXji8FLMGJLRFN42VG2cmzroG+lUaWNyx9ukeaeIUfxomVs3rAoZHX/iQlBWJOOYtG2gjThv0DTiEB+7ZBnWTgzuHBv9X8s7PltPAPhGlF7sA0pWOm6a+QzumsaVWBaPeOoe831k+G8J5CmsfoFdm19FNCY5/FB/Y4DwfoCW251Qd9JhWNCVozKpfPPOu/5Dy7u2tV+tK6tcVB+xejcgVMKv8FiiQHeb/mDgfagV1EA0ZLpR57c2H5cSemWJ5NzKxlyFJDB2XRL4NgphQkrBzynDrQcO9h2Cs/bEe+57d5Gn61dqjEm5oWpCOwk4aRkcNQhMForYhdROid6ci4GJoZud+//8ELNWvcBX1B+L9UZ3pLeU9hFhz9XUkEM/RupDCPbRVaR3XOm8/DRS7sqj9Ov0mQXdrl2+Et0Et45t22NNJEAETSJlGCkw9/jEvGk+VOhPcntIiC95FIov+RipLm5hi5KixKD4c+QXgzXivT2Z+d7cwwh01w0upUbWv/yyvnN61u/6uSl5B0jHGSYi6HQr93lEPLGOcuLA7mlBfnoaisiXAy0n+9wX3C2bw+ckzoDnT2BTq5L2boLcRlytKKgpwIonaBBf+7MHzCvD9SU/KUY9pe+YKi7CW/qc2FFFF7b/lXpYLx07WkvUv8aGaO3Bn/L1x0ndp8/tF04sb51f6R7NjVfGXK02JZ6kqUVuIuAwwMnX9/iOSyxU6ZmqIEOtd1SKz+jYNSNpVdd7RysJY4LNuMPoQxlGiSmBW5p+mq9e5fSnZB6tyZ0rgw5ymLKj7k4DXbeWfdSbccZDMDDjhOtOV6l+gSEV28uuhqbOTJSCov+BldUzBRu+J0gbHMf+O/mrUsbPkLQWlq5YCqmMuOoXXCJTkbo818sWvaZh1bUBE6BmhI7Q5wItemeablXMFrfnAQW7HCGP3zjCo/NE/Xvyr1hR2ygIEkR2bvEjKN+wRMRcM6egkbXjFHR/EMrV3d83snOUP0yOxf3mj6vbJr6LiYL0eG28YfO68qTf3i09b1Q9yM8DmNRo9Yy2/3MOKpVNFPeL31q8fjz4X4n3tBK4yHPst63cfWZUzwnjwyc+RP/rfgy9H2npYWBPPtUhhxtC1holS3c5w8OLF/v2xvud0oEbYbvxCo5Fm9HtT/EkAqzHfDwPNPwzmP16yIl1164jiUwnFNyzKt2vZGO+mSlqE+b95Xsnb/eV6uYGexEULN22DJse8EnQRWgIB6EPHn5iskFA7recikXuThhyNETzae5UJGxEM/VvTv+4ENoK5XmEpbGxNZPhi/RfTsddqqg9cdkwver7oPwXfFadrWlVzJDjmJKRHqymDA3NkrBdj2OnF6y7LAu3CdmeylBSnPphHmMTSNW4j0CLw419B6YFUfhVLb5TpjLQulKe+3+h1a1fBbZvi8pmAz3adh0xHQFVpMfTT8c6ooybCWp/6prNQJckicUs2M4ZkLsGiMJzntjlyCSzo8r99yPBf6R7fvmQf/GLiCfjmg65MV6mNHFQyceflx5AnUoNNMiWPnRkDyuo96GTAXj+r4YgrZjeNRtCCpDD3UwkOLBDCw56vVjWiQPSuorA5r4SA+Kwhurf22i4ZF6NDCQaqheWuXK8rwLhhx1uArePrtNPSKmyDl932NbPCeVJh4yw4qm7oAmhx1dNSwwzC5NGXIUyiNkiC5pchRMdPXnZ9aEgqDhl4cgaHftcCt2kWmq/DT+hC1HoU9aG80Zr7/6GrE75GMnf694UISZjg5/rNsTVMYHap65/OlsxU3x7ZuAejulm9MpuF5r+FM3GExgEsbUA487HeVCCC6vr3Hr0CXZnR2Sri005kd/Zs+gR0d+/VMJBCMPO/u9HRFB7AbN/Y0yQUO28do8r/X7Fx035zHS4lrqwhRsKO61tWopJIN7mbf1gtf/vw1bM5CMn1t+cfj1mo6zsjxefxumzc+suIEf8YyUBIrPKboWIBhZKXOOYnT/dCPmKZr1QCv/0Pm3nXYp/hK0S3BZ/FO8K6vuARoyFMYYleF7JlkB9HdrbKcwM8ikjePs2ucFMV/WxddRv/nyR3UxDPo/r53ZtK655kSgqX9++XTXyBmXXa9vDAvLo9ec/WNnFbaS6T1G6VXF5oH3YhqNYR1T0bnzbl1AT17I2NxeeJGdPA+HV/FoKcaQWvmSb+jiRKWp0LXLQX3ZIeExllrPoHvVwLtnl03SBQd8gG/WyRdiq0CHUpeOyqwDv1zd+qXcvOgicKJCJrkqmbf1ct1bWvfB3onk4DZ97omXwt4i6H6m/w+1iwr2gKAoVjawHFfBOVLmHHkRM/20V4FCQNC4VSAdAmiv4leDZuOh0l6OmhIM4ijwgr3VCMRPHqylrOn6igj83MKiqdqDTejdyuyJqyZQWnD6NXz7NO5VlYlYsoxCUFTc/EiHANq/doJuyZLSW40ZPBnEUeCFobG+35uLawMdEx89+1bY0kH3g4O+r73w5UfeUnq3cUtDjY/XvRX3ksrEp468mbwKXJXyaD4WDGDyuZhYuYzjKJqz2w+9aJZYKTzN+nNfyHjBW8wt+JYuA5pftX6Wsg+Hfl6sndSnrHSnqAICvNKBnXy0Hnj59HDpZANcqXEclSG5/8R/acXGkPtfPbUx7I2C7nv76+MzvAKWiaY6gu6Mn2TpRhXdRL2INbffTWqqS6VwiuuGchRP8KrGP2IbghRCcXD58eY/Kw5vQmG1ll1uIrVRyoxMjD3PeBpAxjfGyqAmBR30aWXfVJNTSx5DOQpB0d+auP+pjP2EFlXV34tdRhRPg5N7ir+t/t7kORFJSZ4BV0flDkyZJ0kGPFFJrsqXpuVhL319DnzbSMFKnxJjSjGaoxAAvmR67RMxknCU8O4p7G7XdQTdoY8hdf3U9v+9/aYntyiuLiq/UUslD/dJMdxGFRBDSxWR92Jv9cifLM6zwFGoseXisfsP/JaFPrqUubZth9Iow6vpMlqSBcPCS/iwJDQdlXOZxhg7qphQMCBRFUjHVR2/Y4HeBQrUBfZEhWSHo2DA0taPdQkmJ1Is43T0QyJnkNyaPzrjouLeuK56cVwOgT3VjqKP9XjXild64HosTZGCdN1f+P2gcGxsXXF1zywxOxyFrKApgsl6fVY+M+Xj3rX34rHI9Bt6XRX5U5dzsGRV1SzYFfNQlX9XVPw9vpij16AHRaFApXC5IrkKXVSILOTqQt16t5HFKucGva9X6os6kScLczXdRHrTXfeq3NZDvJOjVmp/vRSltfITUdjWYEehmMNuyZ4BVaDlKdklTYZS9NLxBKNM5vOekouLYT4mbWBOOz803dmMDZe7DjGfHUFRBztqdilgRBXw/YwIKmthk7ZvzeqfTFN+gqa7/WckxEOYsB4NKEwy+0lnTI0FkQT2a0VSo+8POsWyiV8/zEnfFBM6O2W2i4PF+DMzUitlsRyVYjG7YVPWxkxRRgRNsagNqzKi0o3/GTmo7y3Q53tUWaBPTomqfBll4oWjEB40fajpvTsOL89IEV1vQpsVOoodBbqW220L6+kKf8pHdyU54ih0cwq5a5r+4vrybu0THHVHigrMFgJ8cVSmKT4uOGT3fH5GUdmyDdUrI8AdRyWx5FEUB1NPfKKfiJJ1BLjkaBcq29xfd50a9z/6G3JliECd6uga4xtXvylravAw3FCXa46edZ8z3mLVOV3df3/whOe88QKYscZabwO7MD7XHL2yeJjxBqsMdnFUEI7bGboH41VjV+OhYKP01oPNwTdHc9lO+ooL6diCQcqKDiVWGjcnJSoIYLKlcq77Ca8ctYszC8forq2aAofm9QlnC7opChZGI8EZFmQnuKJPMqccxYu1qT1G6aNimqVc0sEQ8w966tIswHLZaz2nmOrMKUeFtrYJJVcw1TxR4fgEfOSljac7VzBHJtJ5JAIf1O8Q2n2RKfqec8pRZ15pWvPWMOnzppolOZ/NwX712EkGi+a0wKQsSUMc6tdN3W1Lfy3IxL33bfdOZy7DiQ1Znj8aV2cMWRYWXhf3UmwiZkv97cEXcIsU13TYNrUdW9+2XzjzFnJOdwydVj4as8SH5/dPa00StphDIXKg1OO9gC5pWg9MrJDdOAWd0Zqmo/Ap7HTkkaPQdnLv1Ku2sS/SXfuf3yrUgUwyn2SYlPONvhPrzhwUzgjoOQDESXkDxuVWYUhUVdinp1BU7CossOXEXZtxa6/rFoRYLhWYl7eucRu+qSUXTv9GIfB2/ceAKCpR35+ic8dcfUvUXpo3eK7xyleSeD4sTlh08OWVF/+EqVJpVacElcBa6cYucBVaxy1N9AU6xq6Ke4kS8Tm1fR0Mo8jwLDz60eTLhdHdXHBkNeiVLkHBpzAX88Lfr0nJM4/DY949flNqpyUD+v0IIYdR1VJW4nu5GzN521tvz7sqrsCYCYVREVphNNyscYkUAHUtOarDRnORZXaP82eOv83aENiflTuOCkHvpPLo6D1GLTftXjJx5yNBh401KHHZs66lRuO2oHGLNXUijLK6fosBKvDHUdHptYc/GYWuJ3Y0GfLFgo2eE0wHj8mxRtULD/1n8jxWu/rwsdeNsQh3HEWkbdKe5XBaYCeiniXb5yxt+NAYLJKTDK5UY9g1efnmugoDGeNEAQuP43qI5W0LvQIWnUyDw+nSAtP2sP9Hund1y/ysh/MKaJNd/bnzo7JwcJzSH8u3FwoK6k8QrOZzjyr1KuiSEyAACl2KUlMIpxxVI7rxefDYzKp9kfU0H+P1SqtG6bMTtS8a2ftyIECdlogWz+xyFuPboVZu8W87/CxAEAyjjYuHfUrMxvqaC3U8b57KFE4ovqXxENMqYguntj4WkxQpLkf+0voNFuyYQmUoDvVTAKT3ZeJoJoiisUOfzIxf7stE29A9UBYqS6284QdxNEPIYa3xX/27RSKmiIZCWSPHSZFWIY5GopHeOWw2esfCbv+OFAqO3HkflM3W8Jo4mh4vI3PDZvCmsF83bvTRUEBBqJktggJw4mgk6zI5lxt9TjZPzUSBxPdAKTQUUDBxFiOuEEd1QBlWnFrzBA+bp+qgTFcRUAdKZZ2gEIc42mUTbf/Dlg+d/j9MIMRUGG0lZf9uqIAFjFCHB4ICDuKobpxA4HBd8z5M1DJ19/Scr/WyHf+6rnWf8XHQRJYgjiZCJpN02BV/CNPc/fVzmdzPwT2z9i73+Nz8EBSQEEf15wWayJXntopb7zDjQIorDyrbxiEEWG13pr/xzVOiy5Yn2MSpXy0dnzvg2SH/xM/Xp1JC2D9QfDbgSZnNuAwBwW6fHX+Bm3FCdNeagtgz3XnK71555r3PmveN6jGowpHlII4apN3+5k0teyC5mswG5BnsLKG2njnOLnuPTe5jCDRO+PJB/lv/2AWPzAFKVQFxNBVCulwPBMHUL3wNaP3RT0XokdstI0cw/tB3BnCKru2zM7iNbtGCAAbOWKLtsvVYNuDmG4rHjCio1FJaynvxwr1BaCm2F0ZtCZjoRvh7PE6JrhqcPimXy31KDEbB+OqUyM6Co28IwdVY+Di3bPx1JSO+WThcL76Cl1+07v+4aS8iDHgeUIX87/tXLJxSFL19QRQCMyrGbz36hiJk1FXjf5IfNR7zmBoDQU8gtP9UiEwIBVxbOGR0j0HK3mnJv/2MBUYXPK3wlEdbT+Gj0Z+01m7F1pYyLwVBjjB0VomK/M3j84a8MOKeJD5VnujEyUsm+FHR9eldMZhRQpYR6KQspADV5EN0SmyLjBOKgpQtIoOcUcqW6gBT55ZPfGLIDxNt/IZOs5pyUtWjw/VJ+VUUe9IBR92LQOin88+WY5f/5GCQiB0Ruv4EKbbVeRV5um5RIwzu2u4+/PTJ3/e054wrujz2ltr247s76i95JGIzGZJCsSdDYOayErhJhBrQIcY2b7ERMXyMQBrY8XFQ7IkPO2RJCqlBDwQxBw9jeXRDFSmG5vVTzrN+QhzNugmyL4AUu/XUY749liZj3hP+lhx/k5P+KNChMVP2KcKPBMogDKzlRCqMmRw89Is5gYPEcIl5Av5wRAYQsohLUJKD2vosWoCqVoUAcVQVTJQpiwgQR7MIPlWtCgHiqCqYKFMWESCOZhF8qjoVAja8VRMc0rs1OggBjhGg9UwcG4dECyFAbT0RgXcEiKO8W4jkI44SB3hHgDjKu4VIPuIocYB3BGhOCe8WsrJ8IuaUePzkR63MAXPoThw1h52sLCVx1MrWN4fuxFFz2MnKUhJHrWx9c+hOHDWHnawspUMa3tNBCHCMAPlRjo1DooUQII4SEXhHgDjKu4VIPuIocYB3BIijvFuI5KM5JcQBjhGgfUo4Ng6JFkaA2vowFnTGJwLEUT7tQlKFESCOhrGgMz4RII7yaReSKowAcTSMBZ3xiQDtU8KnXUiqEAKhjZ7IjxIbeEeA9iTj3UIkH/lR4gDvCBBHebcQyUccJQ7wjgDNKeHdQiQf+VHiAO8IEEd5txDJRxwlDvCOAHGUdwuRfBTDJw7wjoCjF75gTgchwDEC/w8JMszGlzjMVQAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);

// QQ 图标
export const QQIcon: React.FC<IconProps> = ({ className, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="10" cy="10" r="8.5" fill="currentColor" />
    <path
      d="M14.8 12.5c-.1-.3-.3-.6-.5-.9 0 0 .3-1.5.3-2.3 0-1.6-.7-3.8-2.1-4.5-.2-.4-.6-.7-1.1-.8h-1.3c-.5.1-.9.4-1.1.8-1.4.7-2.1 2.9-2.1 4.5 0 .8.3 2.3.3 2.3-.2.3-.4.6-.5.9-.2.5-.1 1 .3 1.2.2.1.4.1.6 0 .1 0 .2-.1.3-.2.1.4.3.8.6 1.1-.4.2-.7.5-.7 1 0 .4.3.7.6.9.5.2 1.1.3 1.7.3s1.2-.1 1.7-.3c.3-.2.6-.5.6-.9 0-.5-.3-.8-.7-1 .3-.3.5-.7.6-1.1.1.1.2.2.3.2.2.1.4.1.6 0 .4-.2.5-.7.3-1.2z"
      fill="white"
    />
  </svg>
);

// 空格键图标 - 用于虚拟键盘
export const SpaceKeyIcon: React.FC<IconProps> = ({ className, width = 28, height = 8 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 1V7H27V1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// 删除键图标 - 用于虚拟键盘（按设计稿绘制）
export const DeleteKeyIcon: React.FC<IconProps> = ({ className, width = 45, height = 30 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 45 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* 外框：左侧箭头 + 右侧矩形 */}
    <path
      d="M15 5L5 15L15 25H40V5H15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* X 符号 */}
    <path d="M24 11L32 19M32 11L24 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

{
  /* 播放详情页播放按钮icon */
}
export const PlayDetailPlayIcon: React.FC<IconProps> = () => (
  <svg id="svg-wetv-play-detail-play-icon" viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1191_29557)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38309 10.613C8.80339 13.665 8.5 16.812 8.5 20.0285C8.5 23.2245 8.7993 26.3515 9.37134 29.385C9.66553 30.9425 11.0512 31.994 12.5681 32H12.5937C12.9527 31.9985 13.3189 31.9385 13.6795 31.8125C16.6914 30.76 19.6476 29.4205 22.5104 27.7845C25.3072 26.186 28.101 24.585 30.2681 22.3785C32.018 20.5985 31.8035 18.943 30.2559 17.5225C27.9488 15.4055 25.2184 13.697 22.3786 12.099C19.5547 10.51 16.6424 9.2085 13.6775 8.1835C13.3164 8.059 12.9497 8 12.5901 8C11.0696 8 9.67881 9.053 9.38309 10.613Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1191_29557">
        <rect width="24" height="24" fill="currentColor" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

{
  /* 播放详情页播放列表按钮icon */
}
export const PlayDetailPlayListIcon: React.FC<IconProps> = () => (
  <svg id="svg-wetv-play-detail-play-list-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
    <path d="M16 9H34V21" stroke="currentColor" strokeWidth="2" />
    <rect x="7" y="15" width="21" height="16" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const PlayDetailUpdateIcon: React.FC<IconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
    <rect x="6.3999" y="7.2002" width="19.2" height="19.2" stroke="white" strokeWidth="2" />
    <rect x="6.3999" y="12.7998" width="19.2" height="2" fill="white" />
    <rect x="10.3999" y="4" width="2" height="4" fill="white" />
    <rect x="19.6001" y="4" width="2" height="4" fill="white" />
  </svg>
);

/* 海报占位图海报 */
export const PosterImagePlaceholderIcon: React.FC<IconProps> = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.3">
      <path
        d="M44.4425 20.4734C38.3931 15.8263 31.5012 11.7347 24.3409 9.42046C19.0551 7.71254 16.9399 9.64726 15.8105 13.2112C16.1901 13.2853 16.5928 13.3778 17.0186 13.4936C23.6975 15.2987 30.1312 18.497 35.778 22.1304C36.0603 22.334 36.3704 22.5469 36.699 22.7737C38.7171 24.1623 41.3368 25.9628 41.397 28.041C41.3368 30.1192 38.7217 31.9197 36.7037 33.3082C36.375 33.535 36.0603 33.7479 35.778 33.9516C30.1312 37.585 23.6975 40.7787 17.0186 42.5884C16.5928 42.7041 16.1901 42.7967 15.8105 42.8707C16.9353 46.4347 19.0551 48.3694 24.3409 46.6615C31.4966 44.3472 38.3931 40.2556 44.4425 35.6086C44.7434 35.3494 45.0767 35.0763 45.4284 34.7894C47.5899 33.012 50.3994 30.707 50.4642 28.0456C50.3994 25.3888 47.5992 23.0838 45.4377 21.3065C45.0859 21.0149 44.748 20.7418 44.4425 20.478V20.4734Z"
        fill="white"
      />
      <path
        d="M14.7735 37.7691C14.3477 34.543 14.1903 31.8307 14.1903 28.04C14.1903 24.2492 14.3338 21.5091 14.7735 18.3108C15.0096 16.6168 15.278 15.0061 15.8103 13.2102C10.3116 12.141 9.08044 15.2468 8.26119 19.5189C7.73354 22.3376 7.57617 25.1796 7.57617 28.04C7.57617 30.9004 7.73354 33.7423 8.26119 36.5564C9.08044 40.8286 10.3116 43.9297 15.8149 42.8697C15.3984 41.6293 15.0003 39.4724 14.7781 37.7691H14.7735Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8149 28.0316C15.8149 25.5646 15.9723 19.8576 17.1804 15.2754C17.509 15.3402 17.8561 15.4235 18.2218 15.5207C23.9704 17.0759 29.5107 19.8252 34.3707 22.9541C34.6206 23.1207 34.9076 23.3012 35.2131 23.4956C37.0459 24.6574 39.5685 26.2589 39.6194 28.0408C39.5685 29.8274 37.0506 31.4243 35.2131 32.5907C34.9122 32.7804 34.6299 32.961 34.3753 33.1276C29.5154 36.2518 23.9796 39.0058 18.2264 40.561C17.8607 40.6628 17.5136 40.7415 17.185 40.8063C16.0695 36.9507 15.8196 30.5032 15.8196 28.0362L15.8149 28.0316ZM22.1977 22.5838C21.7163 22.4496 21.4016 22.6023 21.2766 23.1624C21.2766 23.1624 20.9572 23.6761 20.9572 28.0501C20.9572 32.424 21.2766 32.9193 21.2766 32.9193C21.3877 33.4608 21.6145 33.6321 22.1977 33.4979C22.1977 33.4979 23.1697 33.3451 27.0854 31.3595C31.0011 29.3646 31.6537 28.624 31.6537 28.624C32.0703 28.1982 32.1814 27.9205 31.6537 27.4669C31.6537 27.4669 30.5799 26.4718 27.0854 24.6713C23.6279 22.8847 22.1977 22.5884 22.1977 22.5884V22.5838Z"
        fill="white"
      />
    </g>
  </svg>
);

export const PlayIcon: React.FC<IconProps> = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4013_21838)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.5212 2.8743C0.883528 6.2315 0.549805 9.6932 0.549805 13.2313C0.549805 16.7469 0.879034 20.1867 1.50828 23.5235C1.83189 25.2367 3.35612 26.3934 5.02474 26.4H5.05283C5.44779 26.3983 5.85062 26.3323 6.24727 26.1938C9.56035 25.036 12.8122 23.5625 15.9612 21.7629C19.0378 20.0046 22.1109 18.2435 24.4948 15.8163C26.4196 13.8583 26.1836 12.0373 24.4813 10.4747C21.9435 8.14605 18.94 6.2667 15.8163 4.5089C12.7099 2.761 9.50641 1.32935 6.24502 0.20185C5.84781 0.0649 5.44442 0 5.0489 0C3.37634 0 1.8465 1.1583 1.5212 2.8743Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4013_21838">
        <rect width="26.4" height="26.4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RefreshIcon: React.FC<IconProps> = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 14.1663H5V5.83301" stroke="white" strokeWidth="2.5" strokeLinecap="square" strokeLinejoin="round" />
    <path
      d="M5 23.1579C6.46646 29.9258 12.5498 35 19.8316 35C28.2089 35 35 28.2843 35 20C35 11.7157 28.2089 5 19.8316 5C14.3836 5 9.6064 7.84034 6.93168 12.1053L5.83333 13.75"
      stroke="white"
      strokeWidth="2.5"
    />
  </svg>
);

// 排行榜数字icon
export const RankIcon1: React.FC<IconProps> = ({ className, width = 306, height = 360 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 306 360"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask
      id="mask0_4460_3353"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="304"
      height="360"
    >
      <rect width="303.238" height="360" fill="url(#paint0_linear_4460_3353)" />
    </mask>
    <g mask="url(#mask0_4460_3353)">
      <g clip-path="url(#clip0_4460_3353)">
        <mask
          id="mask1_4460_3353"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="-2"
          width="270"
          height="360"
        >
          <rect x="1.67188" y="-2" width="268.657" height="360" fill="url(#paint1_linear_4460_3353)" />
        </mask>
        <g mask="url(#mask1_4460_3353)"></g>
        <g clip-path="url(#clip1_4460_3353)">
          <g filter="url(#filter0_iiiiif_4460_3353)">
            <path
              d="M106.374 344.941V157.717H103.464L46.2296 197.49V153.513L106.536 111.638H155.201V344.941H106.374Z"
              fill="white"
              fill-opacity="0.05"
            />
          </g>
          <g filter="url(#filter1_iiiiii_4460_3353)">
            <path
              d="M107.002 345.2V157.975H104.092L46.8575 197.749V153.772L107.164 111.897H155.829V345.2H107.002Z"
              fill="white"
              fill-opacity="0.05"
            />
          </g>
          <mask
            id="mask2_4460_3353"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="46"
            y="111"
            width="110"
            height="235"
          >
            <path
              d="M107.002 345.2V157.975H104.092L46.8575 197.749V153.772L107.164 111.897H155.829V345.2H107.002Z"
              fill="white"
              fill-opacity="0.2"
            />
          </mask>
          <g mask="url(#mask2_4460_3353)">
            <g filter="url(#filter2_f_4460_3353)">
              <rect x="-9" y="228" width="163" height="117" fill="url(#paint2_linear_4460_3353)" />
            </g>
            <g filter="url(#filter3_f_4460_3353)">
              <rect
                x="93.1133"
                y="70.3398"
                width="64.7198"
                height="148.909"
                transform="rotate(54.6494 93.1133 70.3398)"
                fill="url(#paint3_linear_4460_3353)"
                fill-opacity="0.5"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iiiiif_4460_3353"
        x="38.9795"
        y="104.388"
        width="123.472"
        height="247.803"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.725" />
        <feGaussianBlur stdDeviation="0.3625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.725" dy="0.725" />
        <feGaussianBlur stdDeviation="0.3625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="effect1_innerShadow_4460_3353" result="effect2_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.725" dy="-1.45" />
        <feGaussianBlur stdDeviation="0.3625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="effect2_innerShadow_4460_3353" result="effect3_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.45" dy="-0.725" />
        <feGaussianBlur stdDeviation="0.3625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="effect3_innerShadow_4460_3353" result="effect4_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.725" dy="1.45" />
        <feGaussianBlur stdDeviation="0.3625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="effect4_innerShadow_4460_3353" result="effect5_innerShadow_4460_3353" />
        <feGaussianBlur stdDeviation="3.625" result="effect6_foregroundBlur_4460_3353" />
      </filter>
      <filter
        id="filter1_iiiiii_4460_3353"
        x="44.8574"
        y="109.897"
        width="112.972"
        height="237.303"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="effect1_innerShadow_4460_3353" result="effect2_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="-2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="effect2_innerShadow_4460_3353" result="effect3_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="-2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect3_innerShadow_4460_3353" result="effect4_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect4_innerShadow_4460_3353" result="effect5_innerShadow_4460_3353" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="-2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="effect5_innerShadow_4460_3353" result="effect6_innerShadow_4460_3353" />
      </filter>
      <filter
        id="filter2_f_4460_3353"
        x="-29"
        y="208"
        width="203"
        height="157"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_4460_3353" />
      </filter>
      <filter
        id="filter3_f_4460_3353"
        x="-64.5908"
        y="34.0898"
        width="231.399"
        height="211.443"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="18.125" result="effect1_foregroundBlur_4460_3353" />
      </filter>
      <linearGradient
        id="paint0_linear_4460_3353"
        x1="158.167"
        y1="180"
        x2="109.81"
        y2="180"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4460_3353"
        x1="1.67188"
        y1="178"
        x2="270.329"
        y2="178"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.6" />
        <stop offset="0.7" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4460_3353"
        x1="92"
        y1="268.5"
        x2="105.358"
        y2="343.357"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E3E3" stop-opacity="0" />
        <stop offset="0.734512" stop-color="#00B2B2" />
        <stop offset="1" stop-color="#00FFFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4460_3353"
        x1="105.577"
        y1="111.811"
        x2="165.886"
        y2="199.182"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E3E3" stop-opacity="0" />
        <stop offset="0.76011" stop-color="#00E4E4" />
        <stop offset="1" stop-color="#01FFFF" />
      </linearGradient>
      <clipPath id="clip0_4460_3353">
        <rect width="305.116" height="360" fill="white" transform="translate(0.884277)" />
      </clipPath>
      <clipPath id="clip1_4460_3353">
        <rect width="228" height="261" fill="white" transform="translate(-19 97)" />
      </clipPath>
    </defs>
  </svg>
);
